import React from 'react';
// @ts-ignore
import png from './primary-ellipse.png';

import s from './PrimarySpinner.module.scss';

export const PrimarySpinner = () => <img src={png} className={s.spinner} />;
